import { sortMapByIndex } from "@/components/FormEngine/helpers/sortFields";
import { FormStep } from "@/components/FormEngine/types";

import { StyledStepContainer, StyledStepTitle } from "../../styles";
import { BaseRendererProps } from "../../types";
import { SectionRenderer } from "../SectionRenderer";

interface StepRendererProps extends BaseRendererProps {
  step: FormStep;
  stepIndex: number;
  fieldsMap?: Record<string, any>; // NEW
}

export const StepRenderer: React.FC<StepRendererProps> = ({
  step,
  stepIndex,
  formState,
  onFieldChange,
  fieldsMap, // NEW
}) => (
  <StyledStepContainer>
    <StyledStepTitle variant='title1'>Étape {stepIndex}</StyledStepTitle>

    {sortMapByIndex(step.sections).map(([sectionIndex, section]) => (
      <SectionRenderer
        key={section.id}
        section={section}
        sectionIndex={sectionIndex}
        formState={formState}
        onFieldChange={onFieldChange}
        fieldsMap={fieldsMap} // NEW
      />
    ))}
  </StyledStepContainer>
);
